import DBEngine from '@/database/_Base';
import SyncEngine from '@/database/_Sync';
import Helper from '@/resources/Helper';
import ModelStockSyncData from '@/resources/models/StockSyncData';

const tableName = 'stock';

const functions = {
    operandAction() {
        return {
            initial: 'initial', // First setup inventory
            increase: 'increase', // Increase stock via inventory
            decrease: 'decrease', // Decrease stock via inventory
            deduct: 'deduct', // Deduct when closing job
            delete: 'delete', // Delete dot
            reserve: 'reserve', // Reserve when booking or open job
            return: 'return', // Return reserve if cancel booking or adjust product in job
            purchase: 'purchase', // Return reserve when closing job
        };
    },
    stockType() {
        return {
            normal: 'normal',
            sublet: 'sublet',
            consign: 'consign'
        };
    },
    async get() {
        await this.sync();

        return await DBEngine.getContentList(tableName);
    },
    async sync() {
        // Sync Data with Server
        await SyncEngine.syncDataVersion(tableName);
    },
    async getDetail(key) {
        const currentData = await this.get();
        
        return await DBEngine.getContentDetailByKey(currentData, key);
    },
    async initialStock(key) {
        const currentData = await this.get();

        const value = {
            key: key,
            reserve: 0,
            dots: [{
                name: '',
                amountNormal: 0,
                amountSublet: 0,
                amountConsign: 0
            }]
        };

        currentData.content.push(value);

        // Setup Current IndexedDB
		await DBEngine.replaceRecord(tableName, currentData.content, currentData.version);

		// Sync Pipeline
		SyncEngine.setupSyncPipeline(tableName, DBEngine.syncAction().add, value);
    },
    async save(stockValue, syncValue, operation) {
        const currentData = await this.get();
        
        // Stamp Update Time
		stockValue['timestamp'] = Helper.getClientTime();

        for (let index = 0; index < currentData.content.length; index++) {
            if (currentData.content[index].key === stockValue.key) {
                currentData.content[index] = stockValue;
                break;
            }
        }

        // Setup Current IndexedDB
		await DBEngine.replaceRecord(tableName, currentData.content, currentData.version);

        // Sync
        SyncEngine.setupSyncPipeline(tableName, operation, syncValue);
    },
    async reserveStockData(syncData) {
        const stockData = await this.getDetail(syncData.key);
        const amount = parseInt(syncData.amount);

        stockData.reserve += amount;
        
        await this.save(stockData, syncData, DBEngine.syncAction().reserveStock);
    },
    async deleteDot(stockData, key, name) {
        const syncData = ModelStockSyncData.data();
        syncData.key = key;
        syncData.dot = name;
        syncData.operand = this.operandAction().decrease;
        syncData.amount = 0;

        await this.save(stockData, syncData, DBEngine.syncAction().deleteDot);
    },
    async returnReserveData(syncData) {
        const stockData = await this.getDetail(syncData.key);
        const amount = parseInt(syncData.amount);
        
        stockData.reserve -= amount;
        
        await this.save(stockData, syncData, DBEngine.syncAction().returnReserve);

        return stockData;
    },
    generateDotOption(dots, blankName) {
        const option = [];

        if (dots) {
            dots.forEach((item) => {
                option.push({
                    id: item.name || '-',
                    name: item.name || blankName
                });
            });
        } else {
            option.push({
                id: '-',
                name: blankName
            });
        }
        
        return option;
    },
}

export default functions;